module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Clear-6a1d73a50a97b3cbe48650feffb8809d.woff";